module.exports = __webpack_public_path__ + "assets/img/service2.9d827e0c.png";